import React from 'react';
import ProspectLayout from '../../../layouts/ProspectLayout';
import FaqsLayout from './FaqsLayout';

const SimpleFaqsPage = () => {
    return (
        <ProspectLayout>
            <FaqsLayout simple={true} webTour={false} />
        </ProspectLayout>
    );
};

export default SimpleFaqsPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/SimpleFaqsPage.tsx